
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/suppliers",
      function () {
        return require("private-next-pages/marketplace/suppliers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace/suppliers"])
      });
    }
  